import RevxFlexLayout from 'components/RevxFlexLayout';
import { ConfigSvcProps } from '..';
import CommonJobSvcBorder from '../common/CommonJobSvcBorder';
import CommonJobSvcCotainer from '../common/CommonJobSvcCotainer';
import CommonJobSvcInstructions from '../common/CommonJobSvcInstructions';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcName from '../common/CommonJobSvcName';
import CommonJobSvcOption from '../common/CommonJobSvcOption';
import CommonJobSvcSpec from '../common/CommonJobSvcSpec';
import CommonQuantityPerBundle from '../common/CommonQuantityPerBundle';
import { useHideSvc } from '../hook/useHideSvc';
import { useHideSvcContainer } from '../hook/useHideSvcContainer';

const HandWork = (props: ConfigSvcProps) => {
  const hideSvc = useHideSvc(props);
  const hideSvcContainer = useHideSvcContainer(props);
  // const typeRadioProps: RevxRadioProps = {
  //   outSideRevxLayoutProps: {
  //     align: 'top',
  //     justify: 'left',
  //     wrap: 'wrap',
  //     className: 'jobconfig-jobOption-content-outSideOption-default',
  //     style: {
  //       paddingBottom: 0,
  //       marginTop: 20,
  //     },
  //   },
  //   inSideRevxLayoutProps: {
  //     align: 'top',
  //     justify: 'left',
  //     className: 'jobconfig-jobOption-content-inSideOption-default',
  //     style: {
  //       marginRight: 31,
  //     },
  //   },
  //   options: [
  //     {
  //       value: 'Hand Assembly',
  //       children: <span>Hand Assembly</span>,
  //     },
  //     {
  //       value: 'Elastic Knotted String',
  //       children: <span>Elastic Knotted String</span>,
  //     },
  //   ],
  // };

  return (
    <>
      <div style={hideSvc}>
        <RevxFlexLayout align="top" justify="justify-start">
          <CommonJobSvcName {...props} />
          <div>
            {/* <div
          className="jobconfig-jobOption-content-label"
          style={{ margin: '21px 0 14px 0' }}
        >
          Type
        </div>
        <Form.Item name={[id, 'spec']} noStyle>
          <RevxRadio {...typeRadioProps} />
        </Form.Item> */}
            {/* <div className="base-service-container" hidden={hideSvcContainer}> */}
            <CommonJobSvcCotainer {...props}>
              <CommonJobSvcSpec {...props} disabled={hideSvcContainer} />
              <CommonJobSvcOption {...props} disabled={hideSvcContainer} />
              <CommonQuantityPerBundle {...props} disabled={hideSvcContainer} />
              <CommonJobSvcInstructions
                {...props}
                disabled={hideSvcContainer}
              />
              <CommonJobSvcMessage {...props} disabled={hideSvcContainer} />
            </CommonJobSvcCotainer>
          </div>
        </RevxFlexLayout>
        <CommonJobSvcBorder />
      </div>
    </>
  );
};

export default HandWork;
